import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AtInternetService } from './services/at-internet.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {

	constructor(private translate: TranslateService) {
	}

	ngOnInit() {
		this.setLang();
	}

	private setLang(): void {
		this.translate.setDefaultLang('fr');
		this.translate.use('fr');
	}

	/*
		private useBrowserLang(): void {
			const langs = ['fr', 'en'];
			this.translate.setDefaultLang('fr');
			if (langs.indexOf(this.translate.getBrowserLang()) > -1) {
				this.translate.use(this.translate.getBrowserLang());
			} else {
				this.translate.use('en');
			}
		}*/
}
